import { Text } from '@ayble-health/dashboard-components';
import React from 'react';
import styled from '@emotion/styled';
import { Box, Image } from '@chakra-ui/react';
import { theme } from '../../theme/theme';
import type { EmotionTheme } from '../../theme/emotionTheme';

const chevronRight = '/chevron-right-small.svg';

const Action = styled('div')<{ isSelected: boolean; theme?: EmotionTheme }>`
  align-items: center;
  background-color: white;
  border: 2px solid ${theme.colors.cloud['200']};
  border-radius: 8px;
  cursor: pointer;
  display: flex;
  height: 48px;
  justify-content: space-between;
  max-width: 260px;
  padding: 4px 16px;
  position: relative;

  & > div:nth-child(2) {
    transform: ${({ isSelected }) =>
      isSelected
        ? 'rotate(180deg);'
        : 'rotate(0deg)'}; /* Move the chevron horizontally */
    transition: transform 0.3s ease; /* Smooth transition */
  }

  /* Apply border-left when isSelected is true */
  ${({ isSelected, theme }) =>
    isSelected &&
    `
    &::after {
      border-bottom-left-radius: 8px;
      border-top-left-radius: 8px;
      content: '';
      position: absolute;
      top: -1px;
      left: -2px;
      width: 6px; /* Border width */
      height: calc(100% + 2px); /* Full height of the parent element */
      background-color: ${theme.colors.secondary['100']}; /* Border color */
    }
  `}
`;

type Props = React.ComponentProps<typeof Box> & {
  disabled?: boolean;
  isSelected?: boolean;
  onClick: () => void;
  text: string;
};

export const UserDashboardSideContentAction = ({
  disabled = false,
  isSelected = false,
  onClick,
  text,
  ...boxProps
}: Props) => {
  return (
    <Box
      {...boxProps}
      opacity={disabled ? 0.4 : 1}
      pointerEvents={disabled ? 'none' : undefined}
      aria-disabled={disabled}
    >
      <Action isSelected={isSelected} onClick={disabled ? () => {} : onClick}>
        <Text
          color={'secondary.500'}
          fontSize={'16px'}
          fontWeight={'normal'}
          pl={2}
        >
          {text}
        </Text>

        <Image boxSize={'20px'} src={chevronRight} />
      </Action>
    </Box>
  );
};
